import { z } from "zod";
import { isDefined } from "../lib/common";

export enum OrderLineItemFulfillmentStatus {
  PENDING = "PENDING",
  IN_PROGRESS = "IN_PROGRESS",
  PARTIALLY_FULFILLED = "PARTIALLY_FULFILLED",
  FULFILLED = "FULFILLED",
  FAILED = "FAILED",
}

export enum OrderLineItemShippingStatus {
  PENDING = "PENDING",
  SHIPPED = "SHIPPED",
  DELIVERED = "DELIVERED",
}

export const updateOrderLineItemRequestSchema = z
  .object({
    fulfillmentStatus: z.nativeEnum(OrderLineItemFulfillmentStatus).optional(),
    shippingStatus: z.nativeEnum(OrderLineItemShippingStatus).optional(),
    note: z.string().min(1).optional(),
    trackingNumber: z.string().min(1).optional(),
  })
  .refine(
    (data) =>
      isDefined(data.fulfillmentStatus) ||
      isDefined(data.shippingStatus) ||
      isDefined(data.note) ||
      isDefined(data.trackingNumber),
    {
      message:
        "At least one of fulfillmentStatus, shippingStatus, note, or trackingNumber must be provided",
    },
  );

export type UpdateOrderLineItemRequestDto = z.infer<typeof updateOrderLineItemRequestSchema>;

export const updateOrderLineItemResponseSchema = z.object({
  id: z.string(),
  productId: z.string(),
  variantId: z.string(),
  quantity: z.number(),
  price: z.number(),
  fulfillmentStatus: z.nativeEnum(OrderLineItemFulfillmentStatus).nullish(),
  shippingStatus: z.nativeEnum(OrderLineItemShippingStatus).nullish(),
  metadata: z.record(z.string(), z.unknown()).nullish(),
});

export type UpdateOrderLineItemResponseDto = z.infer<typeof updateOrderLineItemResponseSchema>;
